module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "info-control"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.userInfo.idCardNo) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "info-control",
    staticStyle: {
      "margin-top": "0.35rem"
    }
  }, [_c('span', [_vm._v("联系电话:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "tel",
      "placeholder": "输入您的电话号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "keyup": function($event) {
        return _vm.validPhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('RegionSelect', {
    on: {
      "doctorGroup": _vm.getGroupId
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "info-control checkbox ",
      class: {
        active: _vm.items[index].isChoose
      },
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _vm._l((_vm.protocol), function(item, index) {
    return _c('div', {
      staticClass: "herf radio",
      class: {
        active: item.isChooseProtocol, first: index == 0
      },
      on: {
        "click": function($event) {
          return _vm.chooseProtocol()
        }
      }
    }, [_c('a', {
      staticClass: "disabled",
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "ok-wrap"
  }, [_c('button', {
    staticClass: "btn-ok",
    class: {
      disable: _vm.getSubmitState
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交签约申请")])]), _vm._v(" "), _c('tips', {
    model: {
      value: (_vm.showTips),
      callback: function($$v) {
        _vm.showTips = $$v
      },
      expression: "showTips"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "tip-content",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._v(_vm._s(_vm.tips))])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-control",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('span', [_vm._v("请选择您关注的重点")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de9d6cba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/familyDoctor/NoSigned.vue
// module id = 880
// module chunks = 0